import orders from "./orders";
import statistics from "./statistics";
import viewerStatistics from "./viewer-statistics";
import vaccountPayments from "./vaccount-payments";

export const nshop = {
    orders,
    statistics,
    viewerStatistics,
    vaccountPayments,
};

export default nshop;
